import { franc } from 'franc';

export const getEnContent = (data: string[]) => {
  if (data.length === 1) return data[0];

  const [content] = data.filter((text) => {
    return franc(text) === 'eng';
  });

  return content || data[0];
};
